import {h} from 'preact';
import cx from 'classnames';
import Button from '../../common/Button';
import invoke from 'lodash.invoke';
import {GetBrandReviewSummary} from '@services/BrandReviews/query.graphql';

const ModeratorActions = ( props, context ) => {
    const {id, status, updateReviewStatus} = props;
    const refetchQueries = [{
        query: GetBrandReviewSummary,
        variables: context.getPaginationVars()
    }];

    const {loading} = updateReviewStatus.result;

    const handlePublish = () => !loading &&
        updateReviewStatus.mutation( {
            variables: {input: {id, status: 'APPROVED'}},
            refetchQueries
        } );

    const handleUnpublish = () => !loading &&
        updateReviewStatus.mutation( {
            variables: {input: {id, status: 'PENDING'}},
            refetchQueries
        } );

    return <div className="mt-4 md:m-0 md:flex flex-1 md:justify-end">
        {status === 0 ?
            <Button onClick={() => invoke( props, 'onDenyReview', id )}
                    secondary
                    fillMobile
                    data-testid="test-deny"
                    className="my-1 md:my-0 md:ml-2">Deny</Button>
            : null
        }

        {status === 1
            ?
            <Button onClick={handleUnpublish}
                    loading={loading}
                    fillMobile
                    data-testid="test-unpublish"
                    className={cx(
                        'my-1 md:my-0 md:ml-2',
                        {
                            'error': loading,
                            'secondary': !loading
                        }
                    )}>{loading ? 'Unpublishing' : 'Unpublish'}</Button>
            :
            <Button onClick={handlePublish}
                    loading={loading}
                    fillMobile
                    data-testid="test-publish"
                    className={
                        cx(
                            'my-1 md:my-0 md:ml-2',
                            {'success': loading}
                        )
                    }>{loading ? 'Publishing' : 'Publish'}</Button>
        }
    </div>
};

export default ModeratorActions;